import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { ALL_ROUTES, ADD_KRISHAK_SCREEN, COMMON, SYNC_SERVICE } from '../../global/Constants';
import './krishak.css';
import Header from '../common/Header';
import DesktopFooter from '../common/DesktopFooter';
import { HeaderTypes } from "../../global/Enum";
import General from './General';
import Cropping from './Cropping';
import BrandLoyalty from './BrandLoyalty';
import Prerak from './Prerak';
import LastStep from './LastStep';
import Utilities from '../../global/Utilities';
import Loader from '../common/loader/Loader';
import ApiServices from '../../providers/ApiServices';
import { v4 as uuidv4 } from 'uuid';
import SyncServices from '../../providers/SyncServices';
import SyncLoader from '../common/loader/SyncLoader';
import { toast } from 'react-toastify';


class AddKrishakPage extends Component {

    constructor(props) {
        super(props)
        this.goBack = this.goBack.bind(this);
        this.state = {
            currentTab: 0,
            filledTabs: [4],
            selectedCropIds: [],
            selectedCropGroupIds: [],
            isPrerakVisible: false,
            isKrishakForEdit: false,
            isLoading: false,
            isNextEnable: true,
            krishakInfo: {},
            errorMsg: "",
            krishakDataForEdit: null,
            stateId: 0,
        }
    }

    componentDidMount() {

        let krishakData;
        if (this.props.location.state !== undefined) {
            krishakData = this.props.location.state.krishakInfo;
            if (krishakData) {
                this.setKrishakDataForEdit(krishakData);
                this.setState({ isKrishakForEdit: true, isPrerakVisible: krishakData.is_prerak === 1 });
                document.getElementById("next").disabled = false;
                document.getElementById("submit").disabled = false;
            }
        }
    }

    setKrishakDataForEdit = (krishakData) => {
        this.setState({
            krishakDataForEdit: krishakData
        })
    }

    goBack() {
        this.props.history.goBack();
    }

    _handleCancelClick = (e) => {
        this.goBack();
    }
    _handlePreviousClick = (e) => {
        e.preventDefault();
        var selectedTab;
        const { currentTab } = this.state;
        if (currentTab !== 0) {
            if (currentTab === 4) {
                const { isPrerakVisible } = this.state;
                if (!isPrerakVisible) {
                    selectedTab = currentTab - 2;
                    this.setState({
                        currentTab: selectedTab
                    });
                } else {
                    selectedTab = currentTab - 1;
                    this.setState({
                        currentTab: selectedTab
                    });
                }
            } else {
                selectedTab = currentTab - 1;
                this.setState({
                    currentTab: selectedTab
                });
            }
        }
        if (!this.state.isKrishakForEdit) {
            document.getElementById("next").disabled = !this.state.filledTabs.some(e => e === selectedTab);
        }
    }
    _handleNextClick = (e) => {
        e.preventDefault();
        var selectedTab;
        const { currentTab, krishakInfo } = this.state;

        if (currentTab === 1) {
            let cropping = krishakInfo.cropping;
            let general = krishakInfo?.general;

            if (cropping && cropping !== undefined) {
                let tempArray = [];
                let tempGroupArray = [];

                let cropsPlanted = cropping.cropsPlanted;

                for (var i = 0; i < cropsPlanted.length; i++) {
                    let crop = cropsPlanted[i];
                    tempArray.push(crop.crop_id);
                    if (!tempGroupArray.includes(crop.crop_group_id)) {
                        tempGroupArray.push(crop.crop_group_id);
                    }
                    this.setState({
                        selectedCropIds: tempArray,
                        selectedCropGroupIds: tempGroupArray,
                        stateId: general?.locationDetails?.selectedState?.value
                    })
                }
            }
        }

        if (currentTab === 2) {
            const { isPrerakVisible } = this.state;
            if (isPrerakVisible) {
                selectedTab = currentTab + 1;
                this.setState({
                    currentTab: selectedTab
                });
            } else {
                selectedTab = currentTab + 2;
                this.setState({
                    currentTab: selectedTab
                });
            }
        } else if (currentTab !== 4) {
            selectedTab = currentTab + 1;
            this.setState({
                currentTab: selectedTab
            });
        }
        const newArray = this.state.filledTabs.slice(); // Create a copy


        if (!newArray.some(e => e === currentTab)) {
            /* currentTab not contains the element we're looking for */
            newArray.push(currentTab);
        }

        Utilities.LogPrint("filledTabsselectedTab", newArray);
        this.setState({ filledTabs: newArray }, () => {
            if (!this.state.isKrishakForEdit) {
                if (selectedTab !== 4) {
                    document.getElementById("next").disabled = !newArray.some(e => e === selectedTab);
                } else {
                    document.getElementById("submit").disabled = !newArray.some(e => e === selectedTab);
                }
            }

            if (selectedTab === 2) {
                document.getElementById("next").disabled = false;
            }
        });
    }

    _handleSubmitClick = (e) => {
        e.preventDefault();
        Utilities.LogPrint("isKrishakForEdit", this.state.isKrishakForEdit);
        if (this.state.isKrishakForEdit) {
            // this.editkrishak();
            this.editKrishakInLocal();
        } else {
            // this.addKrishak();
            this.addKrishakInLocal();
        }

    }

    addKrishakInLocal() {
        let uuid = uuidv4();
        Utilities.LogPrint("uuid", uuid);

        const { krishakInfo, isPrerakVisible } = this.state;

        let fellow_farmer_images = [];
        let krishak_images = [];
        let fellow_farmer_image = [];
        let krishak_image = [];
        let nearest_dr = [];
        let prerakData = {};

        if (krishakInfo.general.additionalDetails.prerakMobileNumber) {
            prerakData = {
                krishak_id: krishakInfo.general.additionalDetails.prerakMobileNumber.value,
                name: krishakInfo.general.additionalDetails.prerakMobileNumber.label.split('(', 2)[0],
                phone: (krishakInfo.general.additionalDetails.prerakMobileNumber.label.split('(', 2)[1]).replace(")", ""),
            };
        }
        for (let i = 0; i < krishakInfo.last_step.imagesFiles.length; i++) {
            krishak_image.push(krishakInfo.last_step.imagesFiles[i].file.name);
        }
        // Utilities.LogPrint("addKrishakInLocalImage", krishakInfo.prerak.farmer_mobile_images);
        if (isPrerakVisible) {

            for (let i = 0; i < krishakInfo.prerak.farmer_mobile_images_files.length; i++) {
                fellow_farmer_image.push(krishakInfo.prerak.farmer_mobile_images_files[i].file.name);
            }


            if (krishakInfo.prerak.farmer_mobile_images !== undefined || krishakInfo.prerak.farmer_mobile_images) {
                for (let i = 0; i < krishakInfo.prerak.farmer_mobile_images.length; i++) {
                    if (krishakInfo.prerak.farmer_mobile_images[i].image_name) {
                        // fellow_farmer_image.push(krishakInfo.prerak.farmer_mobile_images[i].image_name)
                        fellow_farmer_images.push({
                            image_url: krishakInfo.prerak.farmer_mobile_images[i].image_url,
                            krishak_fellow_farmer_image_id: 0,
                            image_name: krishakInfo.prerak.farmer_mobile_images[i].image_name
                        })
                    }
                }
            }
        }
        if (isPrerakVisible) {
            for (let i = 0; i < krishakInfo.prerak.nearest_dr.length; i++) {
                nearest_dr.push({
                    retailer_id: krishakInfo.prerak.nearest_dr[i].value,
                    retailer_name: krishakInfo.prerak.nearest_dr[i].label.split('(', 2)[0],
                    phone: (krishakInfo.prerak.nearest_dr[i].label.split('(', 2)[1]).replace(")", ""),
                });
            }
        }

        if (krishakInfo.last_step.images !== undefined || krishakInfo.last_step.images) {
            for (let i = 0; i < krishakInfo.last_step.images.length; i++) {
                if (krishakInfo.last_step.images[i].image_name) {
                    // krishak_image.push(krishakInfo.last_step.images[i].image_name);
                    krishak_images.push({
                        image_url: krishakInfo.last_step.images[i].image_url,
                        krishak_image_id: 0,
                        image_name: krishakInfo.last_step.images[i].image_name
                    });
                }
            }
        }

        let village_id = krishakInfo.general.locationDetails.selectedVillage ? krishakInfo.general.locationDetails.selectedVillage.value : 0
        let village_name = krishakInfo.general.locationDetails.selectedVillage ? krishakInfo.general.locationDetails.selectedVillage.label : ""
        var krishakObject = {
            krishak_id: 0,
            temp_krishak_id: uuid,
            phone: krishakInfo.general.personalDetails.mobile,
            is_prerak: krishakInfo.general.additionalDetails.canPrerak,
            name: krishakInfo.general.personalDetails.name,
            dob: krishakInfo.general.personalDetails.dob,
            state_id: krishakInfo.general.locationDetails.selectedState.value,
            district_id: krishakInfo.general.locationDetails.selectedDistrict.value,
            tehsil_id: krishakInfo.general.locationDetails.selectedTehsil.value,
            village_id: village_id,
            qualification_id: krishakInfo.general.additionalDetails.education,
            is_smart_phone: krishakInfo.general.additionalDetails.isSmartPhoneUser,
            phone_app_id: krishakInfo.general.additionalDetails.appsUsed,
            is_know_prerak: krishakInfo.general.additionalDetails.isPrerak,
            prerak_name_phone: prerakData,
            irrigation_source_id: krishakInfo?.general?.irrigationSource?.irrigation?.irrigation_source_id,
            total_owned: (krishakInfo.cropping && krishakInfo.cropping !== undefined) ? krishakInfo.cropping.total_owned : 0,
            total_owned_area_unit_id: (krishakInfo.cropping && krishakInfo.cropping !== undefined) ? krishakInfo.cropping.total_owned_area_unit_id : 0,
            total_leased: (krishakInfo.cropping && krishakInfo.cropping !== undefined) ? krishakInfo.cropping.total_leased : 0,
            total_leased_area_unit_id: (krishakInfo.cropping && krishakInfo.cropping !== undefined) ? krishakInfo.cropping.total_leased_area_unit_id : 0,
            irrigated: (krishakInfo.cropping && krishakInfo.cropping !== undefined) ? krishakInfo.cropping.irrigated : 0,
            irrigated_area_unit_id: (krishakInfo.cropping && krishakInfo.cropping !== undefined) ? krishakInfo.cropping.irrigated_area_unit_id : 0,
            rainfed: (krishakInfo.cropping && krishakInfo.cropping !== undefined) ? krishakInfo.cropping.rainfed : 0,
            rainfed_area_unit_id: (krishakInfo.cropping && krishakInfo.cropping !== undefined) ? krishakInfo.cropping.rainfed_area_unit_id : 0,
            brans_purchaseed: (krishakInfo.brand_loyalty && krishakInfo.brand_loyalty !== undefined) ? krishakInfo.brand_loyalty.brand_purchased : [],
            krishak_source_of_information_id: isPrerakVisible ? krishakInfo.prerak.source_of_information.value : 0,
            krishak_decision_making_id: isPrerakVisible ? krishakInfo.prerak.decision_making ? krishakInfo.prerak.decision_making.value : 0 : 0,
            favourite_tv: isPrerakVisible ? krishakInfo.prerak.fav_tv_show : "",
            favourite_radio: isPrerakVisible ? krishakInfo.prerak.fav_radio_show : "",
            favourite_news: isPrerakVisible ? krishakInfo.prerak.fav_newspaper : "",
            krishak_near_retailers: nearest_dr,
            krishak_near_retailer: nearest_dr,
            krishak_influence_factors: isPrerakVisible ? krishakInfo.prerak.factors_influence_purchase.map(({ value: influence_factor_id, label: influence_factor_name }) => ({ influence_factor_id, influence_factor_name })) : [],
            krishak_influence_factor: isPrerakVisible ? krishakInfo.prerak.factors_influence_purchase.map(({ value: influence_factor_id, label: influence_factor_name }) => ({ influence_factor_id, influence_factor_name })) : [],
            krishak_fellow_farmer_phones: isPrerakVisible ? krishakInfo.prerak.farmer_mobile_numbers ? krishakInfo.prerak.farmer_mobile_numbers : [] : [],
            krishak_fellow_farmer_phone: isPrerakVisible ? krishakInfo.prerak.farmer_mobile_numbers ? krishakInfo.prerak.farmer_mobile_numbers : [] : [],
            latitude: krishakInfo.last_step.latlong ? krishakInfo.last_step.latlong.latitude : 0,
            longitude: krishakInfo.last_step.latlong ? krishakInfo.last_step.latlong.longitude : 0,
            krishak_crops_planteds: (krishakInfo.cropping && krishakInfo.cropping !== undefined) ? krishakInfo.cropping.cropsPlanted : [],
            krishak_crops_planted: (krishakInfo.cropping && krishakInfo.cropping !== undefined) ? krishakInfo.cropping.cropsPlanted : [],
            krishak_other_brands: (krishakInfo.brand_loyalty && krishakInfo.brand_loyalty !== undefined) ? krishakInfo.brand_loyalty.other_hybrid_brands : [],
            krishak_other_brand: (krishakInfo.brand_loyalty && krishakInfo.brand_loyalty !== undefined) ? krishakInfo.brand_loyalty.other_hybrid_brands : [],
            krishak_hybrid_purchaseds: (krishakInfo.brand_loyalty && krishakInfo.brand_loyalty !== undefined) ? krishakInfo.brand_loyalty.us_brands : [],
            krishak_hybrid_purchased: (krishakInfo.brand_loyalty && krishakInfo.brand_loyalty !== undefined) ? krishakInfo.brand_loyalty.us_brands : [],
            remark: krishakInfo.last_step.remarks,
            krishak_fellow_farmer_image: fellow_farmer_image,
            krishak_fellow_farmer_images: fellow_farmer_images,
            krishak_image: krishak_image,
            krishak_images: krishak_images,
            state_name: krishakInfo.general.locationDetails.selectedState.label,
            district_name: krishakInfo.general.locationDetails.selectedDistrict.label,
            village_name: krishakInfo.general.locationDetails.selectedTehsil.label,
            tehsil_name: village_name,
            delete_krishak_image: krishakInfo.last_step.delete_krishak_image,
            delete_krishak_fellow_farmer_image: isPrerakVisible ? krishakInfo.prerak.delete_krishak_fellow_farmer_image : [],
            qualification_name: krishakInfo.general.additionalDetails.educationName,
            irrigation_source_name: krishakInfo?.general?.irrigationSource?.irrigation.name,
            total_owned_area_unit_name: "Acres",
            total_leased_area_unit_name: "Acres",
            irrigated_area_unit_name: "Acres",
            rainfed_area_unit_name: "Acres",
            krishak_source_of_information_name: isPrerakVisible ? krishakInfo.prerak.source_of_information.label : "",
            krishak_decision_making_name: isPrerakVisible ? krishakInfo.prerak.decision_making ? krishakInfo.prerak.decision_making.label : "" : "",
            phone_app: krishakInfo.general.additionalDetails.selectedApps.map(({ value: phone_app_id, label: name }) => ({ phone_app_id, name })),
            imagesFiles: krishakInfo.last_step.imagesFiles,
            farmer_mobile_images_files: isPrerakVisible ? krishakInfo.prerak.farmer_mobile_images_files : []
        };

        let images = krishakInfo.last_step.imagesFiles;
        for (var i = 0; i < images.length; i++) {
            this.getByteArray(images[i].file, images[i].name).then(result => {
                Utilities.LogPrint("getByteArrayData", result);
                SyncServices.addKrishakImageToDatabase(result.byteArray, result.name);
            });
        }
        let fellowFarmerImages = [];
        if (isPrerakVisible) {
            fellowFarmerImages = krishakInfo.prerak.farmer_mobile_images_files;
            for (let i = 0; i < fellowFarmerImages.length; i++) {
                this.getByteArray(fellowFarmerImages[i].file, fellowFarmerImages[i].name).then(result => {
                    SyncServices.addKrishakImageToDatabase(result.byteArray, result.name);
                });
            }
        }
        SyncServices.updateKrishakToDatabase(krishakObject, krishakInfo.general.personalDetails.mobile, isPrerakVisible ? "true" : "false", krishakObject.krishak_id.toString(), krishakObject.temp_krishak_id);

        if (navigator.onLine) {
            this.syncKrishakData(krishakObject, images, fellowFarmerImages, true);
        } else {
            toast.info('Krishak Added Successfully');
            this.props.history.replace(ALL_ROUTES.HOME_TODAY_ROUTE);
        }
        Utilities.LogPrint("addKrishakInLocal", krishakObject);
    }

    editKrishakInLocal() {

        const { krishakInfo, isPrerakVisible, krishakDataForEdit } = this.state;
        Utilities.LogPrint("editKrishakInLocalkrishakInfo", krishakInfo);
        let fellow_farmer_images = [];
        let krishak_images = [];
        let fellow_farmer_image = [];
        let krishak_image = [];
        let nearest_dr = [];
        let prerakData = {};

        if (krishakInfo.general.additionalDetails.prerakMobileNumber) {
            prerakData = {
                krishak_id: krishakInfo.general.additionalDetails.prerakMobileNumber.value,
                name: krishakInfo.general.additionalDetails.prerakMobileNumber.label.split('(', 2)[0],
                phone: (krishakInfo.general.additionalDetails.prerakMobileNumber.label.split('(', 2)[1]).replace(")", ""),
            };
        }

        // Utilities.LogPrint("editKrishakInLocalImage", krishakInfo.prerak.farmer_mobile_images);
        if (isPrerakVisible) {

            for (let i = 0; i < krishakInfo?.prerak?.farmer_mobile_images_files.length; i++) {
                fellow_farmer_image.push(krishakInfo.prerak.farmer_mobile_images_files[i].file.name);
            }

            if (krishakInfo?.prerak?.farmer_mobile_images !== undefined || krishakInfo?.prerak?.farmer_mobile_images) {
                for (let i = 0; i < krishakInfo.prerak.farmer_mobile_images.length; i++) {
                    if (krishakInfo.prerak.farmer_mobile_images[i].image_name) {
                        // fellow_farmer_image.push(krishakInfo.prerak.farmer_mobile_images[i].image_name)
                        fellow_farmer_images.push({
                            image_url: krishakInfo.prerak.farmer_mobile_images[i].image_url,
                            krishak_fellow_farmer_image_id: 0,
                            image_name: krishakInfo.prerak.farmer_mobile_images[i].image_name
                        })
                    }
                }
            }
        }
        if (isPrerakVisible) {
            for (let i = 0; i < krishakInfo.prerak?.nearest_dr.length; i++) {
                nearest_dr.push({
                    retailer_id: krishakInfo.prerak.nearest_dr[i].value,
                    retailer_name: krishakInfo.prerak.nearest_dr[i].label.split('(', 2)[0],
                    phone: (krishakInfo.prerak.nearest_dr[i].label.split('(', 2)[1]).replace(")", ""),
                });
            }
        }

        for (let i = 0; i < krishakInfo.last_step.imagesFiles.length; i++) {
            krishak_image.push(krishakInfo.last_step.imagesFiles[i].file.name);
        }

        if (krishakInfo.last_step.images !== undefined || krishakInfo.last_step.images) {
            for (let i = 0; i < krishakInfo.last_step.images.length; i++) {
                if (krishakInfo.last_step.images[i].image_name) {
                    // krishak_image.push(krishakInfo.last_step.images[i].image_name);
                    krishak_images.push({
                        image_url: krishakInfo.last_step.images[i].image_url,
                        krishak_image_id: 0,
                        image_name: krishakInfo.last_step.images[i].image_name
                    });
                }
            }
        }

        let village_id = krishakInfo.general.locationDetails.selectedVillage ? krishakInfo.general.locationDetails.selectedVillage.value : 0
        let village_name = krishakInfo.general.locationDetails.selectedVillage ? krishakInfo.general.locationDetails.selectedVillage.label : ""
        var krishakObject = {
            temp_krishak_id: krishakDataForEdit.temp_krishak_id,
            krishak_id: krishakDataForEdit.krishak_id,
            phone: krishakDataForEdit.phone,
            is_prerak: krishakInfo.general.additionalDetails.canPrerak,
            name: krishakInfo.general.personalDetails.name,
            dob: krishakInfo.general.personalDetails.dob,
            state_id: krishakInfo.general.locationDetails.selectedState.value,
            district_id: krishakInfo.general.locationDetails.selectedDistrict.value,
            tehsil_id: krishakInfo.general.locationDetails.selectedTehsil.value,
            village_id: village_id,
            qualification_id: krishakInfo.general.additionalDetails.education,
            is_smart_phone: krishakInfo.general.additionalDetails.isSmartPhoneUser,
            phone_app_id: krishakInfo.general.additionalDetails.appsUsed,
            is_know_prerak: krishakInfo.general.additionalDetails.isPrerak,
            prerak_name_phone: prerakData,
            irrigation_source_id: krishakInfo?.general?.irrigationSource?.irrigation?.irrigation_source_id,
            total_owned: (krishakInfo.cropping && krishakInfo.cropping !== undefined) ? krishakInfo.cropping.total_owned : 0,
            total_owned_area_unit_id: (krishakInfo.cropping && krishakInfo.cropping !== undefined) ? krishakInfo.cropping.total_owned_area_unit_id : 0,
            total_leased: (krishakInfo.cropping && krishakInfo.cropping !== undefined) ? krishakInfo.cropping.total_leased : 0,
            total_leased_area_unit_id: (krishakInfo.cropping && krishakInfo.cropping !== undefined) ? krishakInfo.cropping.total_leased_area_unit_id : 0,
            irrigated: (krishakInfo.cropping && krishakInfo.cropping !== undefined) ? krishakInfo.cropping.irrigated : 0,
            irrigated_area_unit_id: (krishakInfo.cropping && krishakInfo.cropping !== undefined) ? krishakInfo.cropping.irrigated_area_unit_id : 0,
            rainfed: (krishakInfo.cropping && krishakInfo.cropping !== undefined) ? krishakInfo.cropping.rainfed : 0,
            rainfed_area_unit_id: (krishakInfo.cropping && krishakInfo.cropping !== undefined) ? krishakInfo.cropping.rainfed_area_unit_id : 0,
            brans_purchaseed: (krishakInfo.brand_loyalty && krishakInfo.brand_loyalty !== undefined) ? krishakInfo.brand_loyalty.brand_purchased : [],
            krishak_source_of_information_id: isPrerakVisible ? krishakInfo?.prerak.source_of_information.value : 0,
            krishak_decision_making_id: isPrerakVisible ? krishakInfo.prerak?.decision_making ? krishakInfo.prerak.decision_making.value : 0 : 0,
            favourite_tv: isPrerakVisible ? krishakInfo.prerak?.fav_tv_show : "",
            favourite_radio: isPrerakVisible ? krishakInfo.prerak?.fav_radio_show : "",
            favourite_news: isPrerakVisible ? krishakInfo.prerak?.fav_newspaper : "",
            krishak_near_retailers: nearest_dr,
            krishak_near_retailer: nearest_dr,
            krishak_influence_factors: isPrerakVisible ? krishakInfo.prerak.factors_influence_purchase.map(({ value: influence_factor_id, label: influence_factor_name }) => ({ influence_factor_id, influence_factor_name })) : [],
            krishak_influence_factor: isPrerakVisible ? krishakInfo.prerak.factors_influence_purchase.map(({ value: influence_factor_id, label: influence_factor_name }) => ({ influence_factor_id, influence_factor_name })) : [],
            krishak_fellow_farmer_phones: isPrerakVisible ? krishakInfo.prerak.farmer_mobile_numbers ? krishakInfo.prerak.farmer_mobile_numbers : [] : [],
            krishak_fellow_farmer_phone: isPrerakVisible ? krishakInfo.prerak.farmer_mobile_numbers ? krishakInfo.prerak.farmer_mobile_numbers : [] : [],
            latitude: krishakInfo.last_step.latlong ? krishakInfo.last_step.latlong.latitude : 0,
            longitude: krishakInfo.last_step.latlong ? krishakInfo.last_step.latlong.longitude : 0,
            krishak_crops_planted: (krishakInfo.cropping && krishakInfo.cropping !== undefined) ? krishakInfo.cropping.cropsPlanted : [],
            krishak_crops_planteds: (krishakInfo.cropping && krishakInfo.cropping !== undefined) ? krishakInfo.cropping.cropsPlanted : [],
            krishak_other_brands: (krishakInfo.brand_loyalty && krishakInfo.brand_loyalty !== undefined) ? krishakInfo.brand_loyalty.other_hybrid_brands : [],
            krishak_other_brand: (krishakInfo.brand_loyalty && krishakInfo.brand_loyalty !== undefined) ? krishakInfo.brand_loyalty.other_hybrid_brands : [],
            krishak_hybrid_purchaseds: (krishakInfo.brand_loyalty && krishakInfo.brand_loyalty !== undefined) ? krishakInfo.brand_loyalty.us_brands : [],
            krishak_hybrid_purchased: (krishakInfo.brand_loyalty && krishakInfo.brand_loyalty !== undefined) ? krishakInfo.brand_loyalty.us_brands : [],
            remark: krishakInfo.last_step.remarks,
            delete_krishak_image: krishakInfo.last_step.delete_krishak_image,
            delete_krishak_fellow_farmer_image: isPrerakVisible ? krishakInfo.prerak.delete_krishak_fellow_farmer_image : [],
            krishak_fellow_farmer_image: fellow_farmer_image,
            krishak_fellow_farmer_images: fellow_farmer_images,
            krishak_images: krishak_images,
            krishak_image: krishak_image,
            state_name: krishakInfo.general.locationDetails.selectedState.label,
            district_name: krishakInfo.general.locationDetails.selectedDistrict.label,
            village_name: krishakInfo.general.locationDetails.selectedTehsil.label,
            tehsil_name: village_name,
            qualification_name: krishakInfo.general.additionalDetails.educationName,
            irrigation_source_name: krishakInfo?.general?.irrigationSource?.irrigation?.name,
            total_owned_area_unit_name: "Acres",
            total_leased_area_unit_name: "Acres",
            irrigated_area_unit_name: "Acres",
            rainfed_area_unit_name: "Acres",
            krishak_source_of_information_name: isPrerakVisible ? krishakInfo.prerak.source_of_information.label : "",
            krishak_decision_making_name: isPrerakVisible ? krishakInfo.prerak.decision_making ? krishakInfo.prerak.decision_making.label : "" : "",
            phone_app: krishakInfo.general.additionalDetails.selectedApps.map(({ value: phone_app_id, label: name }) => ({ phone_app_id, name })),
            imagesFiles: krishakInfo.last_step.imagesFiles,
            farmer_mobile_images_files: isPrerakVisible ? krishakInfo.prerak.farmer_mobile_images_files : []
        };

        let images = krishakInfo.last_step.imagesFiles;
        for (let i = 0; i < images.length; i++) {
            this.getByteArray(images[i].file, images[i].name).then(result => {
                Utilities.LogPrint("getByteArrayData", result);
                SyncServices.addKrishakImageToDatabase(result.byteArray, result.name);
            });
        }
        let fellowFarmerImages = [];
        if (isPrerakVisible) {
            fellowFarmerImages = krishakInfo.prerak.farmer_mobile_images_files;
            for (let i = 0; i < fellowFarmerImages.length; i++) {
                this.getByteArray(fellowFarmerImages[i].file, fellowFarmerImages[i].name).then(result => {
                    Utilities.LogPrint("getByteArrayData", result);
                    SyncServices.addKrishakImageToDatabase(result.byteArray, result.name);
                });
            }
        }
        SyncServices.updateKrishakToDatabase(krishakObject, krishakDataForEdit.phone, isPrerakVisible ? "true" : "false", krishakObject.krishak_id.toString(), krishakObject.temp_krishak_id);

        if (navigator.onLine) {
            Utilities.LogPrint("navigatorIsonLine", "YES");
            this.syncKrishakData(krishakObject, images, fellowFarmerImages, false);
        } else {
            toast.info('Krishak Updated Successfully');
            this.props.history.replace(ALL_ROUTES.HOME_TODAY_ROUTE);
        }

        Utilities.LogPrint("editKrishakInLocal1", krishakObject);
    }



    syncKrishakData = (krishakObject, images, fellowFarmerImages, forAddKrishak) => {

        delete krishakObject?.krishak_images;
        var yourdate = krishakObject.dob.split("/").reverse();
        var tmp = yourdate[2];
        yourdate[2] = yourdate[1];
        yourdate[1] = tmp;
        yourdate = yourdate.join("-");
        yourdate = yourdate.replace("--", "")
        if (krishakObject.prerak_name_phone.krishak_id !== undefined) {
            krishakObject.prerak_name_phone = krishakObject.prerak_name_phone.krishak_id.toString();
        } else {
            krishakObject.prerak_name_phone = "[]";
        }
        krishakObject.dob = yourdate;
        Utilities.LogPrint("krishakObjectForUpdate", krishakObject);
        const lastSyncDate = localStorage.getItem(SYNC_SERVICE.LAST_SYNC_DATE);
        const formData = new FormData();
        let lst_sync = [
            {
                action: "krishak",
                last_sync_date: lastSyncDate,
                data: [krishakObject]
            }
        ]
        formData.append("lst_sync", JSON.stringify(lst_sync));
        for (let i = 0; i < images.length; i++) {
            formData.append("krishak_image", images[i].file);

        }
        for (let i = 0; i < fellowFarmerImages.length; i++) {
            formData.append("krishak_fellow_farmer_image", fellowFarmerImages[i].file);
        }

        this.setState({ isLoading: true });
        try {
            ApiServices.syncKrishakData(formData)
                .then(async response => {
                    Utilities.LogPrint("API_DATA syncData: ---->", response);

                    if (response.success) {
                        let imagesForSave = [];
                        Utilities.LogPrint("Status", response.data);
                        let data = response.data;
                        let KEY = SYNC_SERVICE.ACTION_KRISHAK;
                        var findKrishakActionData = data.find(item => item.action === KEY);

                        for (var i = 0; i < findKrishakActionData.data.length; i++) {
                            let krishak = findKrishakActionData.data[i];
                            if (krishak.krishak_images && krishak.krishak_images !== undefined) {
                                imagesForSave.push(...krishak.krishak_images);
                            }
                            if (krishak.krishak_fellow_farmer_images && krishak.krishak_fellow_farmer_images !== undefined) {
                                imagesForSave.push(...krishak.krishak_fellow_farmer_images);
                            }
                            SyncServices.addKrishakToDatabase(krishak, krishak.phone, (krishak.is_prerak === 1) ? "true" : "false", krishak.krishak_id.toString(), "0");
                        }

                        if (imagesForSave.length === 0) {
                            this.setState({ isLoading: false });
                            toast.info(forAddKrishak ? 'Krishak Added Successfully!' : 'Krishak Updated Successfully!');
                            this.props.history.replace(ALL_ROUTES.HOME_TODAY_ROUTE);
                        }


                        for (var j = 0; j < imagesForSave.length; j++) {
                            try {
                                const arrayBufer = await SyncServices.findKrishakImageFromDatabase("key", imagesForSave[j].image_name);
                                Utilities.LogPrint("arrayBufer123", arrayBufer);
                                if (arrayBufer === null) {
                                    const imageByteArray = await Utilities.getImageBytesFromUrl(imagesForSave[j].image_url);
                                    SyncServices.addKrishakImageToDatabase(imageByteArray, imagesForSave[j].image_name);
                                }
                            } catch (error) {
                                Utilities.LogPrint("imagesForSaveObject", error);
                            }
                            if (j === (imagesForSave.length - 1)) {
                                this.setState({ isLoading: false });
                                toast.info(forAddKrishak ? 'Krishak Added Successfully!' : 'Krishak Updated Successfully!');
                                this.props.history.replace(ALL_ROUTES.HOME_TODAY_ROUTE);
                            }
                        }

                    } else {
                        if (response.message === COMMON.TOKEN_EXPIRED) {
                            Utilities.tokenExpiredRedirectToLogin();
                        }
                        this.setState({ isLoading: false });
                        this.props.history.replace(ALL_ROUTES.HOME_TODAY_ROUTE);
                    }
                }).catch(error => {
                    this.setState({ isLoading: false });
                    Utilities.LogPrint("Status-Catch", error);
                });
        } catch (error) {
            this.setState({ isLoading: false });
            Utilities.LogPrint("Status-Error", error);
        }
    }

    fileToByteArray(file) {
        return new Promise((resolve, reject) => {
            try {
                let reader = new FileReader();
                let fileByteArray = [];
                reader.readAsArrayBuffer(file);
                reader.onloadend = (evt) => {
                    if (evt.target.readyState == FileReader.DONE) {
                        let arrayBuffer = evt.target.result,
                            array = new Uint8Array(arrayBuffer);
                        for (var i = 0; i < array.length; i++) {
                            fileByteArray.push(array[i]);
                        }
                    }
                    resolve(fileByteArray);
                }
            }
            catch (e) {
                reject("Choose a File");
            }
        })
    }

    async getByteArray(myFile, name) {
        let byteArray = await this.fileToByteArray(myFile);
        return {
            byteArray, name
        }
    }

    editkrishak = () => {
        this.setState({ isLoading: true });
        const { krishakInfo, isPrerakVisible, krishakDataForEdit } = this.state;
        Utilities.LogPrint("krishakDataForUpdate", krishakInfo);
        let village_id = krishakInfo.general.locationDetails.selectedVillage ? krishakInfo.general.locationDetails.selectedVillage.value : 0
        const formData = new FormData();
        formData.append("krishak_id", krishakDataForEdit.krishak_id);
        formData.append("is_prerak", krishakInfo.general.additionalDetails.canPrerak);
        formData.append("name", krishakInfo.general.personalDetails.name);
        formData.append("phone", krishakDataForEdit.phone);
        formData.append("dob", krishakInfo.general.personalDetails.dob);
        formData.append("state_id", krishakInfo.general.locationDetails.selectedState.value);
        formData.append("district_id", krishakInfo.general.locationDetails.selectedDistrict.value);
        formData.append("tehsil_id", krishakInfo.general.locationDetails.selectedTehsil.value);
        formData.append("village_id", village_id);
        formData.append("qualification_id", krishakInfo.general.additionalDetails.education);
        formData.append("is_smart_phone", krishakInfo.general.additionalDetails.isSmartPhoneUser);
        formData.append("phone_app_id", JSON.stringify(krishakInfo.general.additionalDetails.appsUsed));
        formData.append("is_know_prerak", krishakInfo.general.additionalDetails.isPrerak);
        formData.append("prerak_name_phone", krishakInfo.general.additionalDetails.prerakMobileNumber.value);
        formData.append("irrigation_source_id", krishakInfo?.general?.irrigationSource?.irrigation?.irrigation_source_id);
        formData.append("total_owned", krishakInfo.cropping.total_owned);
        formData.append("total_owned_area_unit_id", krishakInfo.cropping.total_owned_area_unit_id);
        formData.append("total_leased", krishakInfo.cropping.total_leased);
        formData.append("total_leased_area_unit_id", krishakInfo.cropping.total_leased_area_unit_id);
        formData.append("irrigated", krishakInfo.cropping.irrigated);
        formData.append("irrigated_area_unit_id", krishakInfo.cropping.irrigated_area_unit_id);
        formData.append("rainfed", krishakInfo.cropping.rainfed);
        formData.append("rainfed_area_unit_id", krishakInfo.cropping.rainfed_area_unit_id);
        formData.append("brans_purchaseed", krishakInfo.brand_loyalty.brand_purchased);

        if (isPrerakVisible) {
            for (var i = 0; i < krishakInfo.prerak.farmer_mobile_images.length; i++) {
                formData.append("krishak_fellow_farmer_image", krishakInfo.prerak.farmer_mobile_images[i]);
            }
            formData.append("krishak_source_of_information_id", krishakInfo.prerak.source_of_information.value);
            formData.append("krishak_decision_making_id", krishakInfo.prerak.decision_making.value);
            formData.append("favourite_tv", krishakInfo.prerak.fav_tv_show);
            formData.append("favourite_radio", krishakInfo.prerak.fav_radio_show);
            formData.append("favourite_news", krishakInfo.prerak.fav_newspaper);
            formData.append("krishak_near_retailer", JSON.stringify(krishakInfo.prerak.nearest_dr.map(({ value: retailer_id }) => ({ retailer_id }))));
            formData.append("krishak_influence_factor", JSON.stringify(krishakInfo.prerak.factors_influence_purchase.map(({ value: influence_factor_id }) => ({ influence_factor_id }))));
            formData.append("krishak_fellow_farmer_phone", JSON.stringify(krishakInfo.prerak.farmer_mobile_numbers));
        }

        formData.append("latitude", krishakInfo.last_step.latlong.latitude);
        formData.append("longitude", krishakInfo.last_step.latlong.longitude);
        formData.append("krishak_crops_planted", JSON.stringify(krishakInfo.cropping.cropsPlanted));

        formData.append("krishak_other_brand", JSON.stringify(krishakInfo.brand_loyalty.other_hybrid_brands));

        formData.append("krishak_hybrid_purchased", JSON.stringify(krishakInfo.brand_loyalty.us_brands));

        //formData.append("activity_image", this.state.images);
        formData.append("remark", krishakInfo.last_step.remarks);

        for (let i = 0; i < krishakInfo.last_step.images.length; i++) {
            formData.append("krishak_image", krishakInfo.last_step.images[i]);
        }
        Utilities.LogPrint("krishakInfokrishakInfo", krishakInfo);
        Utilities.LogPrint("krishakInfokrishakInfo", krishakDataForEdit);
        try {
            ApiServices.editkrishak(formData)
                .then(response => {
                    Utilities.LogPrint("API_DATA: ---->", response);
                    this.setState({ isLoading: false });
                    if (response.success) {
                        this.goBack();
                    } else {
                        Utilities.LogPrint("Status", response.message);
                        if (response.message !== undefined && response.message) {
                            this.setState({
                                errorMsg: response.message
                            });
                        }
                    }
                }).catch(error => {
                    this.setState({ isLoading: false, errorMsg: error });
                });
        } catch (error) {
            this.setState({ isLoading: false, errorMsg: error });
        }
    }

    addKrishak = () => {
        this.setState({ isLoading: true });
        const { krishakInfo, isPrerakVisible } = this.state;
        Utilities.LogPrint("krishakDataForAdd", krishakInfo);
        let village_id = krishakInfo.general.locationDetails.selectedVillage ? krishakInfo.general.locationDetails.selectedVillage.value : 0
        const formData = new FormData();
        formData.append("name", krishakInfo.general.personalDetails.name);
        formData.append("phone", krishakInfo.general.personalDetails.mobile);
        formData.append("dob", krishakInfo.general.personalDetails.dob);
        formData.append("state_id", krishakInfo.general.locationDetails.selectedState.value);
        formData.append("district_id", krishakInfo.general.locationDetails.selectedDistrict.value);
        formData.append("tehsil_id", krishakInfo.general.locationDetails.selectedTehsil.value);
        formData.append("village_id", village_id);
        formData.append("is_prerak", krishakInfo.general.additionalDetails.canPrerak);
        formData.append("qualification_id", krishakInfo.general.additionalDetails.education);
        formData.append("is_smart_phone", krishakInfo.general.additionalDetails.isSmartPhoneUser);
        formData.append("phone_app_id", JSON.stringify(krishakInfo.general.additionalDetails.appsUsed));
        formData.append("is_know_prerak", krishakInfo.general.additionalDetails.isPrerak);
        formData.append("prerak_name_phone", krishakInfo.general.additionalDetails.prerakMobileNumber.value);
        formData.append("irrigation_source_id", krishakInfo?.general?.irrigationSource?.irrigation?.irrigation_source_id);
        formData.append("total_owned", krishakInfo.cropping.total_owned);
        formData.append("total_owned_area_unit_id", krishakInfo.cropping.total_owned_area_unit_id);
        formData.append("total_leased", krishakInfo.cropping.total_leased);
        formData.append("total_leased_area_unit_id", krishakInfo.cropping.total_leased_area_unit_id);
        formData.append("irrigated", krishakInfo.cropping.irrigated);
        formData.append("irrigated_area_unit_id", krishakInfo.cropping.irrigated_area_unit_id);
        formData.append("rainfed", krishakInfo.cropping.rainfed);
        formData.append("rainfed_area_unit_id", krishakInfo.cropping.rainfed_area_unit_id);
        formData.append("krishak_crops_planted", JSON.stringify(krishakInfo.cropping.cropsPlanted));
        formData.append("krishak_other_brand", JSON.stringify(krishakInfo.brand_loyalty.other_hybrid_brands));
        formData.append("krishak_hybrid_purchased", JSON.stringify(krishakInfo.brand_loyalty.us_brands));
        formData.append("brans_purchaseed", krishakInfo.brand_loyalty.brand_purchased);

        if (isPrerakVisible) {
            for (var i = 0; i < krishakInfo.prerak.farmer_mobile_images.length; i++) {
                formData.append("krishak_fellow_farmer_image", krishakInfo.prerak.farmer_mobile_images[i]);
            }
            formData.append("krishak_source_of_information_id", krishakInfo.prerak.source_of_information.value);
            formData.append("krishak_decision_making_id", krishakInfo.prerak.decision_making.value);
            formData.append("favourite_tv", krishakInfo.prerak.fav_tv_show);
            formData.append("favourite_radio", krishakInfo.prerak.fav_radio_show);
            formData.append("favourite_news", krishakInfo.prerak.fav_newspaper);
            formData.append("krishak_near_retailer", JSON.stringify(krishakInfo.prerak.nearest_dr.map(({ value: retailer_id }) => ({ retailer_id }))));
            formData.append("krishak_influence_factor", JSON.stringify(krishakInfo.prerak.factors_influence_purchase.map(({ value: influence_factor_id }) => ({ influence_factor_id }))));
            formData.append("krishak_fellow_farmer_phone", JSON.stringify(krishakInfo.prerak.farmer_mobile_numbers));
        }

        formData.append("latitude", krishakInfo.last_step.latlong.latitude);
        formData.append("longitude", krishakInfo.last_step.latlong.longitude);
        // formData.append("krishak_fellow_farmer_image", krishakInfo.last_step);

        //formData.append("activity_image", this.state.images);
        formData.append("remark", krishakInfo.last_step.remarks);

        for (let i = 0; i < krishakInfo.last_step.images.length; i++) {
            formData.append("krishak_image", krishakInfo.last_step.images[i]);
        }
        try {
            ApiServices.addkrishak(formData)
                .then(response => {
                    Utilities.LogPrint("API_DATA: ---->", response);
                    this.setState({ isLoading: false });
                    if (response.success) {
                        this.goBack();
                    } else {
                        Utilities.LogPrint("Status", response.message);
                        if (response.message !== undefined && response.message) {
                            this.setState({
                                errorMsg: response.message
                            });
                        }
                    }
                }).catch(error => {
                    this.setState({ isLoading: false, errorMsg: error });
                });
        } catch (error) {
            this.setState({ isLoading: false, errorMsg: error });
        }
    }

    _handleIsPrerak = (isPrerakVisible) => {
        //Utilities.LogPrint("isPrerakVisibleInAddKrishak", isPrerakVisible);
        this.setState({ isPrerakVisible })
    }

    _handleNextButton = (isNextEnable, tabInfo, name) => {
        const { krishakInfo, currentTab } = this.state;
        const newArray = this.state.filledTabs.slice(); // Create a copy

        if (isNextEnable) {
            krishakInfo[name] = tabInfo;
        }
        this.setState({ isNextEnable, krishakInfo });
        Utilities.LogPrint("krishakInfo", krishakInfo);

        Utilities.LogPrint("currentTab", currentTab);

        //if (!this.state.isKrishakForEdit) {
        if (currentTab === 4) {
            if (isNextEnable) {

                if (!newArray.some(e => e === currentTab)) {
                    /* currentTab not contains the element we're looking for */
                    newArray.push(currentTab);
                }

                Utilities.LogPrint("filledTabsselectedTab", newArray);
            } else {
                if (newArray.some(e => e === currentTab)) {
                    var index = newArray.indexOf(currentTab)
                    if (index !== -1) {
                        newArray.splice(index, 1);
                    }
                }
            }
            this.setState({ filledTabs: newArray });
            document.getElementById("submit").disabled = !isNextEnable;
        } else {
            document.getElementById("next").disabled = !isNextEnable;
        }
        //}
    }

    loaderCallback = (isLoading) => {
        this.setState({ isLoading })
    }

    handleSyncLoading = (loading, tableName) => {
        Utilities.LogPrint("handleSyncLoading", loading + tableName);
        this.setState({ isSyncLoading: loading, tableName })
    }

    render() {

        let krishakData;
        let mobileNumber;
        if (this.props.location.state !== undefined) {
            krishakData = this.props.location.state.krishakInfo;
            mobileNumber = this.props.location.state.mobileNumber;

            if (krishakData && krishakData !== undefined) {
                mobileNumber = krishakData.phone;
            }

        }

        const { currentTab, isLoading, filledTabs, selectedCropIds, selectedCropGroupIds, stateId, isSyncLoading, tableName } = this.state;
        return (
            <div>
                <Header selectedTab={HeaderTypes.KRISHAK} handleSyncLoading={this.handleSyncLoading} />
                {/* <Footer isActive={3} /> */}
                <div className="container pt-35 pb-65">
                    <div className="row">
                        <div className="col-12 krishak-tab-header">
                            <ul>
                                <li className={filledTabs.includes(0) ? "krishak-tab validated active-tab current-tab" : "krishak-tab active-tab current-tab"} data-krishak-tab="general-body"> {/* Use this "validated" className when all field are validated */}
                                    <div className="tab-color"></div>
                                    <i className="krishak-img general"></i>
                                    <span className="d-inline-block w-100">{ADD_KRISHAK_SCREEN.GENERAL}</span>
                                </li>
                                <li className={currentTab > 0 ? filledTabs.includes(1) ? "krishak-tab validated active-tab current-tab" : "krishak-tab active-tab current-tab" : "krishak-tab"} data-krishak-tab="cropping-body">
                                    <div className="tab-color"></div>
                                    <i className="krishak-img cropping"></i>
                                    <span className="d-inline-block w-100">{ADD_KRISHAK_SCREEN.CROPPING}</span>
                                </li>
                                <li className={currentTab > 1 ? filledTabs.includes(2) ? "krishak-tab validated active-tab current-tab" : "krishak-tab active-tab current-tab" : "krishak-tab"} data-krishak-tab="brand-loyalty-body">
                                    <div className="tab-color"></div>
                                    <i className="krishak-img brand-loyalty"></i>
                                    <span className="d-inline-block w-100">{ADD_KRISHAK_SCREEN.BRAND_LOYALTY}</span>
                                </li>
                                <li className={currentTab > 2 ? filledTabs.includes(3) ? "krishak-tab validated active-tab current-tab" : "krishak-tab active-tab current-tab" : "krishak-tab"} data-krishak-tab="prerak-body">
                                    <div className="tab-color"></div>
                                    <i className="krishak-img prerak"></i>
                                    <span className="d-inline-block w-100">{COMMON.PRERAK}</span>
                                </li>
                                <li className={currentTab > 3 ? filledTabs.includes(4) ? "krishak-tab validated active-tab current-tab" : "krishak-tab active-tab current-tab" : "krishak-tab"} data-krishak-tab="last-step-body">
                                    <div className="tab-color"></div>
                                    <i className="krishak-img last-step"></i>
                                    <span className="d-inline-block w-100">{ADD_KRISHAK_SCREEN.LAST_STEP}</span>
                                </li>
                            </ul>
                        </div>

                        <div className="col-12">
                            <General mobileNumber={mobileNumber} krishakData={krishakData} isVisible={currentTab === 0} _handleIsPrerak={this._handleIsPrerak} loaderCallback={this.loaderCallback} _handleNextButton={this._handleNextButton} />
                            <Cropping krishakData={krishakData} isVisible={currentTab === 1} loaderCallback={this.loaderCallback} _handleNextButton={this._handleNextButton} />
                            <BrandLoyalty stateId={stateId} selectedCropIds={selectedCropIds} krishakData={krishakData} isVisible={currentTab === 2} loaderCallback={this.loaderCallback} _handleNextButton={this._handleNextButton} />
                            <Prerak selectedCropGroupIds={selectedCropGroupIds} krishakData={krishakData} isVisible={currentTab === 3} loaderCallback={this.loaderCallback} _handleNextButton={this._handleNextButton} />
                            <LastStep krishakData={krishakData} isVisible={currentTab === 4} loaderCallback={this.loaderCallback} _handleNextButton={this._handleNextButton} />
                            <div className="row">
                                <div className="col-12 d-flex button-grp-bottom">
                                    <button id="cancel" className={currentTab === 0 ? "btn btn-secondary w-50 mr-2 krishak-cancel-btn" : "btn btn-secondary w-50 mr-2 krishak-cancel-btn d-none"} onClick={this._handleCancelClick}>{COMMON.CANCEL}</button>
                                    <button id="previous" className={currentTab === 0 ? "btn btn-secondary w-50 mr-2 d-none" : "btn btn-secondary w-50 mr-2"} onClick={this._handlePreviousClick}>{COMMON.PREVIOUS}</button>
                                    <button id="next" className={currentTab !== 4 ? "btn btn-primary w-50" : "btn btn-primary w-50 d-none"} onClick={this._handleNextClick}>{COMMON.NEXT}</button>
                                    <button id="submit" className={currentTab === 4 ? "btn btn-primary w-50" : "btn btn-primary w-50 d-none"} onClick={this._handleSubmitClick}>{this.state.isKrishakForEdit ? COMMON.UPDATE : COMMON.SUBMIT}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {isLoading ? <Loader /> : null}
                {isSyncLoading ? <SyncLoader tableName={tableName} /> : null}
                <DesktopFooter />
            </div>
        )
    }
}

export default withRouter(AddKrishakPage)